import type { Mission } from '../missions.ts'

export const cms: Mission = {
  id: "cms",
  name: "Centers for Medicare & Medicaid Services",
  short: "CMS",
  call: "Medical",
  kind: "subagency",
  parent: "hhs",
  url: "https://www.cms.gov/",
  established: 1977,
  palette: {
    primary: "#015390",
    secondary: "#009ad0",
    accent: "#f3ce3b",
  },
  colorSource: {
    kind: "brand-guide",
    url: "https://www.cms.gov/about-cms/agency-information/cms-brand-identity/downloads/branding-guide.pdf",
  },
  motif: "swirl",
  mission: {
    text: "Our mission is clear – to serve as a trusted partner and steward, dedicated to advancing health equity, expanding coverage, and improving health outcomes.",
    url: "https://www.cms.gov/about-cms/work-with-us/careers",
  },
  fact: {
    text: "President Lyndon B. Johnson signed the law establishing Medicare and Medicaid on July 30, 1965.",
    url: "https://www.cms.gov/about-cms/who-we-are/history",
  },
  logo: {
    file: "public/logos/cms.svg",
    source: "https://commons.wikimedia.org/wiki/File:Centers_for_Medicare_and_Medicaid_Services_logo.svg",
  },
  identifier: {
    about: "https://www.cms.gov/about-cms",
    accessibility: "https://www.cms.gov/about-cms/web-policies-important-links/accessibility-nondiscrimination-disabilities-notice",
    foia: "https://www.cms.gov/freedom-information-act-foia-service-center",
    noFear: "https://www.cms.gov/about-cms/web-policies-important-links/no-fear-act",
    oig: "https://oig.hhs.gov/",
    performance: "https://www.cms.gov/about-cms/performance-budget/current",
    privacy: "https://www.cms.gov/about-cms/web-policies-important-links/web-policies/privacy",
  },
  media: {
    photos: [
      {
        file: "/media/cms-woodlawn-sculpture.jpg",
        small: "/media/cms-woodlawn-sculpture-sm.jpg",
        alt: "Life-size sculptures of a family walking and running across the lawn outside the CMS headquarters in Woodlawn, Maryland.",
        title: "Sculpture \"Life in the Community\" at CMS headquarters, Woodlawn, Maryland",
        creator: "Carol M. Highsmith",
        source: "https://commons.wikimedia.org/wiki/File:Sculpture_%22Life_in_the_Community%22_in_two_separate_installations_of_six,_located_at_the_exterior_of_the_Health_Care_Financing_Administration_Building,_Woodlawn,_Maryland_LCCN2010720322.jpg",
        license: "Public domain (Carol M. Highsmith Archive, Library of Congress)",
      },
      {
        file: "/media/cms-homage-sculpture.jpg",
        small: "/media/cms-homage-sculpture-sm.jpg",
        alt: "The multistory atrium lobby of the CMS headquarters in Woodlawn, Maryland, with suspended sculpture and balconies.",
        title: "Sculpture \"Homage to Medicare and Medicaid\" in the CMS headquarters lobby",
        creator: "Carol M. Highsmith",
        source: "https://commons.wikimedia.org/wiki/File:Sculpture_%22Homage_to_Medicare_and_Medicaid%22_in_main_lobby_and_links_of_the_Health_Care_Financing_Administration_Building,_Woodlawn,_Maryland_LCCN2010720338.tif",
        license: "Public domain (Carol M. Highsmith Archive, Library of Congress)",
      },
    ],
  },
}
